import { forwardRef, HTMLAttributes, ReactNode } from "react";
import * as SC from "./header.styles";

export interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <SC.HeaderWrapper
        ref={ref}
        className={className}
        style={style}
        {...props}
      >
        <SC.HeaderContent>{children}</SC.HeaderContent>
      </SC.HeaderWrapper>
    );
  }
);

Header.displayName = "Focused.Header";
